import BackButton from 'Components/BackButton'
import Breadcrumbs from 'Components/Breadcrumbs'
import PageTitle from 'Components/PageTitle'
import { WithLoader } from 'Components/WithLoader'
import { ProductForm } from 'Services/ProductManagement/Features/Product/Components/ProductForm'
import { SELECTED_PRODUCT_PARAMETER_KEY } from 'Services/ProductManagement/Features/Product/Hooks/useProductsWithParams'
import { useGetSingleProductQuery } from 'Services/ProductManagement/Features/Product/productApi'
import { usePreviousLocation } from 'Util/Context/previousLocationContext'
import { PRODUCT_MANAGEMENT_ROOT_URL } from 'Util/constants'
import getTranslation from 'Util/getTranslation'
import { Box, Grid } from '@mui/material'
import { useParams } from 'react-router-dom'
import { t } from 'ttag'

export default function ProductEditPage() {
  const baseUrl = `${PRODUCT_MANAGEMENT_ROOT_URL}/products`
  const { id } = useParams()
  const previousLocation = usePreviousLocation(`${baseUrl}?${SELECTED_PRODUCT_PARAMETER_KEY}=${id}`)

  const { data: singleProduct, isLoading } = useGetSingleProductQuery(id ?? '', {
    skip: !id
  })
  const breadcrumbs = [
    {
      title: t`Home`,
      link: PRODUCT_MANAGEMENT_ROOT_URL
    },
    {
      title: t`Products`,
      link: baseUrl
    },
    {
      title: singleProduct ? getTranslation(singleProduct.translations, 'fi').name : ''
    }
  ]

  return (
    <Box sx={{ width: '100%' }}>
      <Grid container spacing={2} mb={4}>
        <Grid size={12}>
          <Breadcrumbs items={breadcrumbs} />
          <BackButton label={t`Back`} link={previousLocation} />
          <PageTitle>{t`Edit product`}</PageTitle>
        </Grid>
      </Grid>
      <WithLoader loading={isLoading}>
        <ProductForm product={singleProduct} successBaseUrl={previousLocation} />
      </WithLoader>
    </Box>
  )
}
